import { useState } from 'react';
import {
  Box,
  ButtonBase,
  Checkbox,
  Dialog,
  FormControlLabel,
  IconButton,
  InputBase,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { eadmissionAPI } from '../../../../../apis';
import { CloseIcon } from '../../../../../components/Icon';
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.625rem',
    backgroundColor: '#fff',
    padding: '0 1.56rem',
    overflow: 'auto',
    marginTop: '2rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    // marginRight: '1.125rem',
    marginLeft: '-10px',
  },
  labelText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#7d86a9',
  },
  inputText: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    fontFamily: 'NotoSans-Medium',
    flex: '50%',
    height: '3.5rem',
    lineHeight: '3.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    backgroundColor: '#fff',
    padding: '0 1.25rem',
    color: '#2e4469',
    fontSize: '1rem',
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
    },
    '& .MuiInputBase-input': {
      height: '3.5rem',
      lineHeight: '3.5rem',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  select: {
    '& .MuiSelect-iconOutlined': {
      color: '#538fff',
    },
  },
  checkBox: {
    marginLeft: '0rem',
    '& .MuiButtonBase-root': {
      padding: '0',
      paddingRight: '0.938rem',
    },
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  cancelBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    border: 'solid 1.5px #538fff',
    color: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    background: '#f5faff',
  },
  configBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
  },
  disconfigBtn: {
    background: '#a7b1c0',
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
  },
}));

export default function SettingEditPop({ handleClose, eid, remarkInput, estatus, version, handleEdit }) {
  const classes = useStyles();
  const [isActive, setIsActive] = useState(estatus);
  const activeChange = (event) => {
    event.target.checked ? setIsActive(1) : setIsActive(0);
  };
  const [remark, setName] = useState(remarkInput);
  const nameHadleChange = (event) => {
    setName(event.target.value);
  };

  return (
    <Dialog open={true} maxWidth={false}>
      <div className={classes.root}>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>Edit Remarks</Typography>
          <IconButton className={classes.closeIcon} stlye={{ marginRight: '-12px' }} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <Typography className={classes.labelText} style={{ marginBottom: '0.625rem' }}>
          Remarks name
        </Typography>
        <InputBase
          className={classes.inputText}
          placeholder="Input"
          onChange={nameHadleChange}
          value={remark}
          inputProps={{ maxLength: 20 }}
        />
        <FormControlLabel
          control={<Checkbox />}
          label="Active"
          className={classes.checkBox}
          checked={Boolean(isActive)}
          onChange={activeChange}
          style={{ marginTop: '1.313rem' }}
        />
        <Box display="flex" justifyContent="center" style={{ margin: '3.125rem 0 1.875rem 0' }}>
          <ButtonBase className={classes.cancelBtn} style={{ marginRight: '1.313rem' }} onClick={handleClose}>
            Cancel
          </ButtonBase>
          <ButtonBase
            className={remark === '' ? classes.disconfigBtn : classes.configBtn}
            style={{ marginRight: '1.313rem' }}
            disabled={remark === '' ? true : false}
            onClick={handleEdit({ remark, status: isActive, version, id: eid, handleClose })}
          >
            Confirm
          </ButtonBase>
        </Box>
      </div>
    </Dialog>
  );
}
